<template>
    <div class="pageView">
      <v-menu></v-menu>
      <div class="swiper mySwiper" v-if="pageshow">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="img">
              <img src="../../assets/images/banner1.jpg" class="bannerimg">
              <div class="banner_02_box">
                <img src="../../assets/images/banner_02_04.png" class="banner_02_01 banner_02_04" :class="{'banner_01_show':animation.show0204banner==1}">
                <img src="../../assets/images/banner_02_03.png" class="banner_02_01 banner_02_03" :class="{'banner_01_show':animation.show0203banner==1}">
                <img src="../../assets/images/banner_02_02.png" class="banner_02_01 banner_02_02" :class="{'banner_01_show':animation.show0202banner==1}">
                <img src="../../assets/images/banner_02_01.png" class="banner_02_01" :class="{'banner_01_show':animation.show0201banner==1}">
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="img">
              <img src="../../assets/images/banner3.jpg" class="bannerimg" />
              <div class="banner3_box">
                <div class="banner3_box_content">
                  <div class="rightxt">
                    <div class="righttxt_box right">
                      <div class="img_inner left" :class="{'imgs':animation.banner3_02==1}" >
                        <img src="../../assets/images/banner3_02.png" title="死心塌地 一切放下" alt="死心塌地 一切放下"/>
                      </div>
                      <div class="img_inner left" :class="{'imgs':animation.banner3_03==1}">
                        <img src="../../assets/images/banner3_03.png" title="心念耳闻 打坐持咒" alt="心念耳闻 打坐持咒" class="left"/>
                      </div>
                      <div class="img_inner left" :class="{'imgs':animation.banner3_04==1}">
                        <img src="../../assets/images/banner3_04.png" title="不压不随 念起即觉" alt="不压不随 念起即觉" class="left"/>
                      </div>
                      <div class="img_inner left" :class="{'imgs':animation.banner3_05==1}">
                        <img src="../../assets/images/banner3_05.png" title="不急不缓 按时上座" alt="不急不缓 按时上座" class="left"/>
                      </div>
                      <div class="img_inner left" :class="{'imgs':animation.banner3_06==1}">
                        <img src="../../assets/images/banner3_06.png" title="绵绵密密  下座观照 " alt="绵绵密密  下座观照 " class="left"/>
                      </div>
                      <div class="img_inner left" :class="{'imgs':animation.banner3_07==1}">
                        <img src="../../assets/images/banner3_07.png" title="容纳一切  心量广大" alt="容纳一切  心量广大" class="left"/>
                      </div>
                      <div class="clear clearfix"></div>
                    </div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="img">
              <img src="../../assets/images/banner2.jpg" class="bannerimg">
              <div class="banner2_box">
                <div class="banner2_box_content_main" >
                  <div class="b2_right">
                    <div class="b2_right_box">
                      <div class="b2_right_box_con">
                        <img src="../../assets/images/b21.png" class="b21" alt="以禅为体" title="以禅为体"/>
                        <img src="../../assets/images/b22.png"  class="b22" alt="以密为用" title="以密为用" :class="{'b22s':animation.b22==1}"/>
                        <img src="../../assets/images/b23.png"  class="b23" alt="以净土为归" title="以净土为归" :class="{'b23s':animation.b23==1}"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="img slide3">
              <img src="../../assets/images/banner4.jpg" class="bannerimg">
              <div class="banner4_box">
                <div class="banner4_box_content">
                  <div class="rightxt">
                    <div class="righttxt_box">
                      <div class="title" >
                        <img src="../../assets/images/b3tit.png" alt="佛法·心中心" title="佛法·心中心">
                      </div>
                      <div class="filebox">
                        <div class="imgitem item1s" :class="{'item1':animation.banner4_item1==1}">
                          <img src="../../assets/images/banner4_02.png" alt="佛法心中心，又称心密、心中心" title="佛法心中心，又称心密、心中心">
                        </div>
                        <div class="imgitem item2s" :class="{'item2':animation.banner4_item2==1}">
                          <img src="../../assets/images/banner4_03.png" alt="法。其法以六印一咒为方便，以" title="法。其法以六印一咒为方便，以">
                        </div>
                        <div class="imgitem item3s" :class="{'item3':animation.banner4_item3==1}">
                          <img src="../../assets/images/banner4_04.png" alt="每日坐禅两小时为功课，以千座" title="每日坐禅两小时为功课，以千座">
                        </div>
                        <div class="imgitem  item4s" :class="{'item4':animation.banner4_item4==1}">
                          <img src="../../assets/images/banner4_5.png" alt="为期，以明心见性为首要目的。" title="为期，以明心见性为首要目的。">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="emptypage" v-if="!pageshow">
        <div class="network">
          <div class="netwrokinner">
            <img src="../../assets/images/network.png" alt="404">
            <div class="networktxt">提示：该网址暂时不能正常访问，建议您稍后再试</div>
          </div>
        </div>
      </div>
      <v-footer v-if="pageshow"></v-footer>
    </div>
</template>

<script>
  // import Swiper from '../../public/dist/js/swiper.min';
  import Swiper from '../../../public/swiper/swiper-bundle.min';
  export default {
        name: "index",
        data() {
            return {
              animation:{
                show0201banner:0,
                show0202banner:0,
                show0203banner:0,
                show0204banner:0,
                b22:0,
                b23:0,
                banner3_left_text:0,
                banner3_02:0,
                banner3_03:0,
                banner3_04:0,
                banner3_05:0,
                banner3_06:0,
                banner3_07:0,
                banner4_item1:0,
                banner4_item2:0,
                banner4_item3:0,
                banner4_item4:0,
              },
              pageshow:true
            }
        },
        mounted() {
          let _this=this
          var swiper = new Swiper(".mySwiper", {
            direction: "vertical",
            slidesPerView: 1,
            speed:1000,
            spaceBetween: 20,
            mousewheel: true,
            pagination: {
              el: ".swiper-pagination",
              bulletActiveClass: 'bullet-active-current',
              clickable: true,
            },
            on: {
              slideChangeTransitionStart: function(){
                if(this.activeIndex==2){
                  setTimeout(()=>{
                    _this.animation.b22=1
                  },500)
                  setTimeout(()=>{
                    _this.animation.b23=1
                  },1000)
                }
              },
              slideChangeTransitionEnd: function(){
                if(this.activeIndex==3){
                  _this.animation.banner4_item1=1
                  setTimeout(()=>{ _this.animation.banner4_item2=1},500)
                  setTimeout(()=>{ _this.animation.banner4_item3=1},1000)
                  setTimeout(()=>{ _this.animation.banner4_item4=1},1500)
                }else if(this.activeIndex==1){
                  _this.animation.banner3_left_text=1
                  _this.animation.banner3_02=1
                  setTimeout(()=>{_this.animation.banner3_03=1},500)
                  setTimeout(()=>{_this.animation.banner3_04=1},1000)
                  setTimeout(()=>{_this.animation.banner3_05=1},1500)
                  setTimeout(()=>{_this.animation.banner3_06=1},2000)
                  setTimeout(()=>{_this.animation.banner3_07=1},2500)
                }
               console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
              },
            },
          });
          this.banner1Make()
        },
        methods: {
          gopage(){
            this.$router.push({name:'page1'})
          },
          banner1Make(){
            setTimeout(()=>{this.animation.show0201banner=1},1000)
            setTimeout(()=>{this.animation.show0202banner=1},1500)
            setTimeout(()=>{this.animation.show0203banner=1},2000)
            setTimeout(()=>{this.animation.show0204banner=1},2500)
          }
        }
    }
</script>
<style>
  .bullet-active-current{
    /*width:0.8rem !important;*/
    height:1.6rem !important;
    border-radius:0.8rem !important;
    opacity: 1 !important;
    background:#5f4009 !important;
  }
</style>
<style scoped lang="scss">
/*404*/
.network{
  position: fixed;
  top:0;
  bottom:0;
  left:0;
  right:0;
  .netwrokinner{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    margin:auto;
    width:400px;
    height:200px;
    text-align: center;
    .networktxt{
      text-align: center;
      font-size:16px;
      color:#999;
    }
  }
}
.swiper {
  width: 100%;
  height: calc(100vh - 7rem);
}
/*.swiper{*/
  /*--swiper-pagination-color: #5f4009;!* 两种都可以 *!*/
/*}*/
.my-pagination-current{
  width:0.8rem !important;
  height:2.3rem;
  background:#5f4009 !important;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  .slide3{

    /*background:url('../../assets/images/banner4.jpg')no-repeat center center;*/
    /*background-size:100% 100%;*/
  }
  .img{
    width:100%;
    height:100%;
    position: relative;
    .bannerimg{
      width:100%;
      height:73rem;
      min-height:100%;
      /*position: absolute;*/
      /*top:8.6rem;*/
      /*left:0;*/
      /*top:0;*/
      /*bottom:0;*/
    }
    .banner_01{
      position: absolute;
      left:12rem;
      width:28rem;
      height:29rem;
      top:50%;
      margin-top:-14.5rem;
      opacity: 0;
      transition:opacity 3s;
    }
    .banner_01_show{
      opacity: 1 !important;
    }
    .banner_02_box{
      position: absolute;
      height:15rem;
      top:50%;
      margin-top:-7.5rem;
      left:53rem;
      width:86rem;
      left:0;
      .banner_02_01{
        width:2.9rem;
        height:15rem;
        opacity:0;
        transition:opacity 1s;
      }
      img{
        margin-right:4rem;
      }
      img:last-child{
        margin-right:0;
      }
    }
    .banner2_box{
      height:43rem;
      width:95rem;
      position: absolute;
      top:18rem;
      left:0;
      right:0;
      margin:auto;
     .banner2_box_content_main{
          width:95rem;
          box-sizing: border-box;
          height:100%;
          position: relative;
          .b2_right{
            position: relative;
            width:100%;
            height:100%;
            .b2_right_box{
              position: absolute;
              left:9rem;
              width:37rem;
              top:0;
              height:38rem;
              .b2_right_box_con{
                position: relative;
                width:100%;
                height:100%;
              }
            }
            img{
              width:4.2rem;
              display: block;
              position: absolute;
              transition: right 0.7s,opacity 0.7s;
            }
            .b21{
              right:3.5rem;
            }
            .b22{
              right:3.5rem;
              opacity: 0;
              top:5.5rem;
            }
            .b22s{
              right:16rem;
              opacity: 1;
              top:5.5rem;
            }
            .b23{
              right:16rem;
              top:11rem;
              opacity: 0;
            }
            .b23s{
              right:30rem;
              opacity: 1;
            }
          }
        }
    }
    .banner3_box{
      position: absolute;
      top:0;
      bottom:0;
      left:0;
      right:0;
      width:100rem;
      margin:auto;
      .banner3_box_content{
        position: relative;
        width:100rem;
        height:100%;
      }
      .banner3_box_content
        .lefttxt{
          position: absolute;
          left:6rem;
          top:-100%;
          opacity:0;
          transition: top 0.5s,opacity 1.5s;
          img{
            width:35rem;
            height:10rem;
          }
        }
        .banner3LeftShow{
          top:10rem !important;
          opacity: 1 !important;
        }
        .rightxt{
          width:65rem;
          height:34rem;
          position: absolute;
          left:0;
          top:0;
          bottom:0;
          margin:auto;
          .img_inner{
            height:0;
            opacity: 0;
            transition: height 2s, opacity 1s;
            overflow: hidden;
            margin-left:5rem;
            img{
              width:6rem;
            }
          }
          .img_inner:first-child{
            margin-left:0;
          }
          .imgs{
            height:33rem;
            opacity: 1;
          }
        }
    }
    .banner4_box{
      position: absolute;
      top:0;
      bottom:0;
      left:0;
      right:0;
      width:95rem;
      margin:auto;
      .banner4_box_content{
        position: relative;
        width:95rem;
        height:100%;
        padding:8rem 0 7rem;
        box-sizing: border-box;
        .lefttxt {
          position: absolute;
          left: 6rem;
          top: -100%;
          opacity: 0;
          transition: top 0.5s, opacity 1.5s;
          img {
            width: 16rem;
          }
        }
        .rightxt{
          position: absolute;
          top:14rem;
          /*bottom:0;*/
          /*margin:auto;*/
          left:9rem;
          width:40rem;
          height:26rem;
          .righttxt_box{
            position: relative;
            width:100%;
            height:100%;
            .title{
              img{
                display: block;
                height:2.9rem;
              }
            }
            .filebox{
              position: relative;
              margin-top:3.5rem;
              height:calc(100% - 5.4rem);
            }
            .title{
              img{
                width:25rem;
                display: block;
              }
            }
            .imgitem{
              position: absolute;
              transition: opacity .5s ,top .5s;
              img{
                width:40rem;
                height:2rem;
              }
            }
            .item1s{
              opacity: 0;
            }
            .item2s{
              top:6rem;
              opacity: 0;
              top:0;
            }
            .item3s{
              opacity: 0;
              top:6rem;
            }
            .item4s{
              top:12rem;
              opacity: 0;
              img{
                width:39rem;
              }
            }
            .item1{
              top:0;
              opacity: 1;
            }
            .item2{
              top:6rem;
              opacity: 1;
            }
            .item3{
              top:12rem;
              opacity: 1;
            }
            .item4{
              top:18rem;
              opacity: 1;
            }
          }

        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/pc/index.vue